import { dateFormater } from "project-config/utils/format-time";

export function getDefaultExportName(
  exportParams: any,
  accountList: any[],
  type: string
) {
  const { userId, taskIds = [], startTime, endTime } = exportParams;
  const { userName } =
    accountList.find((account) => account.userId === userId) || {};

  const identify = userName || userId || taskIds;
  if (!identify || (identify === taskIds && !taskIds.length)) {
    return;
  }

  const startDateStr = dateFormater(new Date(startTime));
  const endDateStr = dateFormater(new Date(endTime));
  const searchDate = `${startDateStr}_${endDateStr}`;
  let exportName =
    identify === taskIds ? searchDate : `${identify}_${searchDate}`;
  switch (type) {
    case "task":
      exportName = exportName + "_tasklist";
      break;
    case "frame":
      exportName = exportName + "_frameslist";
      break;
    case "hardware":
      exportName = "Hardware_" + exportName + "_tasklist";
      break;
  }
  return exportName;
}
